import { Component, input } from '@angular/core';
import { TooltipComponent } from '../../tooltips/tooltip/tooltip.component';

export enum BtnFabPosition {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

@Component({
  selector: 'app-btn-fab',
  standalone: true,
  imports: [TooltipComponent],
  templateUrl: './btn-fab.component.html',
  styleUrl: './btn-fab.component.css',
})
export class BtnFabComponent {
  isDisabled = input<boolean>(false);
  loading = input<boolean>();
  icon = input<string>('fas fa-add');
  size = input<'xs' | 'sm' | 'md' | 'lg'>('sm');
  tooltip = input<string>();
  position = input<BtnFabPosition>(BtnFabPosition.TOP);
  textColor = input<string>(
    'text-primary-500 disabled:bg-gray-200 active:text-primary-500',
  );
  bgColor = input<string>(
    'bg-white disabled:bg-white hover:bg-gray-200 active:bg-gray-300',
  );

  // @Output() clicked: EventEmitter<any> = new EventEmitter();

  // onClick(): void {
  //   this.clicked.emit();
  // }
}
